import React from 'react'
import { NavLink } from 'react-router-dom'

import iconTab1 from '../../images/icon-tab-1.png'
import iconTab1Active from '../../images/icon-tab-1-active.png'
import iconTab2 from '../../images/icon-tab-2.png'
import iconTab2Active from '../../images/icon-tab-2-active.png'

const mainTabBar = ({
  unreadChatrooms
}) => {
  return(
    <div className="candidates__router__wrapper">
      <div className="btn-group" role="group" >
        <NavLink to={"/reports"} activeClassName="active" className="btn btn-secondary">
          <img className="active" src={iconTab1Active} alt='' />
          <img src={iconTab1} alt='' />
          <span>マイページ</span>
        </NavLink>
        <NavLink to={"/support"} activeClassName="active" className="btn btn-secondary">
          <img className="active img-chat" src={iconTab2Active} alt='' />
          <img className="img-chat" src={iconTab2} alt='' />
          <span>サポート</span><span className="d-none d-sm-block">チャット</span>
          {
            unreadChatrooms.length ? <div className="notification-mark">{unreadChatrooms.length}</div> : null
          }
        </NavLink>
      </div>
    </div>
  )
}

export default mainTabBar



// WEBPACK FOOTER //
// ./src/components/MainTabBar/MainTabBar.js